const JID_PATTERN = /^\d+@(c\.us|lid|newsletter|g\.us)$/i;

/**
 * Return a cleaned, displayable phone number for a chat, or `undefined` if the
 * stored phone is not an actual phone number (e.g. a @lid / @newsletter / @g.us
 * identifier). This prevents raw WhatsApp JIDs from being rendered in the UI.
 */
export function displayPhone(phone: string | undefined, externalId: string | undefined): string | undefined {
  if (!phone || phone.trim().length === 0) return undefined;
  if (JID_PATTERN.test(phone.trim())) return undefined;
  if (externalId && !externalId.endsWith('@c.us')) return undefined;
  const digits = phone.replace(/\D/g, '');
  if (digits.length > 15) return undefined;
  return phone.trim();
}
